import {login, loginUser, getInfoAdmin, logout, getInfo} from '@/api/user'
import {getToken, setToken, removeToken} from '@/utils/auth'
import {resetRouter} from '@/router'

const getDefaultState = () => {
    return {
        token: getToken(),
        name: '',
        avatar: ''
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    }
}

const actions = {
    // user login
    login({commit}, userInfo) {
        const {phoneNum, password} = userInfo;
        return new Promise((resolve, reject) => {
            login({phoneNum: phoneNum.trim(), password: password}).then(response => {
                const res = response;
                commit('SET_TOKEN', res);
                setToken(res.Authorization);
                resolve(res)
            }).catch(error => {
                reject(error)
            })

        })
    },

    getInfoAdmin({commit, state}) {
        // return false;
        return new Promise((resolve, reject) => {
            getInfoAdmin().then(response => {
                if (!response) {
                    return reject('权限异常，请重新登录！')
                }

                commit('SET_NAME', response.realName)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // user logout
    logout({commit, state}) {
        return new Promise((resolve, reject) => {
            // logout(state.token).then(() => {
            removeToken() // must remove  token  first
            commit('RESET_STATE')
            resolve()
            // }).catch(error => {
            //   reject(error)
            // })
        })
    },

    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            removeToken() // must remove  token  first
            commit('RESET_STATE')
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

